// The left menu, built from screens.ts: the screens with a `menu` entry, grouped in the order they are listed.
import type { LucideIcon } from 'lucide-react'
import type { Permission } from '@/constants/permissions'
import { SCREENS, type MenuBadge, type MenuGroupName } from './screens'

export interface MenuItem {
  path: string
  label: string
  icon: LucideIcon
  need?: Permission
  badge?: MenuBadge
}

export interface MenuGroup {
  title: MenuGroupName
  items: MenuItem[]
}

export const MENU: MenuGroup[] = SCREENS.reduce<MenuGroup[]>((groups, screen) => {
  if (!screen.menu) return groups
  const { label, group, icon, badge } = screen.menu
  let target = groups.find((g) => g.title === group)
  if (!target) {
    target = { title: group, items: [] }
    groups.push(target)
  }
  target.items.push({ path: screen.path, label, icon, need: screen.need, badge })
  return groups
}, [])

/** Pages outside the app (served from public/), listed last under Help; each opens in a new tab. */
export const HELP_LINKS = [{ href: '/manual/index.html', label: 'Workflow manual' }]

const MENU_PATHS = MENU.flatMap((group) => group.items.map((item) => item.path))

/**
 * The menu item to mark for a URL: the longest menu path it starts with, so /vendors/lender-hub/lenders/freo marks
 * "Lender Hub", not "Vendors" too. Overview (/) only on its own URL.
 */
export function activeMenuPath(pathname: string): string | undefined {
  return MENU_PATHS.filter((path) =>
    path === '/' ? pathname === '/' : pathname === path || pathname.startsWith(path + '/')
  ).sort((a, b) => b.length - a.length)[0]
}
